import { render, staticRenderFns } from "./ztb.vue?vue&type=template&id=391a9845"
import script from "./ztb.vue?vue&type=script&lang=js"
export * from "./ztb.vue?vue&type=script&lang=js"
import style0 from "./ztb.vue?vue&type=style&index=0&id=391a9845&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports